import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=6ad7beb0"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports